import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useNotifications } from "./NotificationHook";
// Set the default state values for each context
export const NotificationContext = /*#__PURE__*/createContext({});
export const NotificationContextProvider = ({
  children
}) => {
  const notifications = useNotifications();
  const notificationContext = useMemo(() => ({
    ...notifications
  }), [notifications.notification]);
  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: notificationContext
  }, children);
};
export const useNotificationContext = () => {
  return useContext(NotificationContext);
};
NotificationContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};